// src/services/orderService.js
import { getData, postData } from "../global/Globalapi";

// Get all orders for a user
export const getUserOrders = async (userId) => {
  const res = await getData(`/orders/user/${userId}`);
  return res.data;  // Axios la JSON data res.data la irukkum
};

// Get details of a single order
export const getOrderDetails = async (orderId) => {
  const res = await getData(`/orders/${orderId}`);
  return res.data;
};

// Cancel an order
export const cancelOrder = async (orderId, userId, reason) => {
  const res = await postData(`/orders/cancel`, { orderId, userId, reason });
  return res.data;
};
